// Single source of truth cho thông tin app hiển thị trên tất cả legal pages.
// Đổi ở đây sẽ propagate sang mọi trang.

export const APP_META = {
  name: 'Social Panel',
  legalEntity: 'Social Panel',
  contactEmail: 'admin@waebox.com',
  websiteUrl: 'https://social-panel.adda.link',
  // Ngày hiệu lực — update mỗi khi nội dung legal thay đổi
  effectiveDate: '2026-06-01',
  jurisdiction: {
    en: 'Vietnam',
    vi: 'Việt Nam',
  },
};

export const t = (key, lang) => TRANSLATIONS[key]?.[lang] ?? TRANSLATIONS[key]?.en ?? key;

export const TRANSLATIONS = {
  // Header / navigation
  brandTagline: {
    en: 'Legal Center',
    vi: 'Trung tâm Pháp lý',
  },
  back: { en: 'Back', vi: 'Quay lại' },
  backToLegal: { en: 'Back to Legal Center', vi: 'Về Trung tâm Pháp lý' },
  backToDashboard: { en: 'Open Dashboard', vi: 'Mở Dashboard' },

  // Index page
  indexTitle: { en: 'Legal Center', vi: 'Trung tâm Pháp lý' },
  indexSubtitle: {
    en:
      'Terms of Service and Privacy Policy for each social platform integrated with Social Panel. These pages are publicly accessible — no login required — so platform reviewers and end-users can read them directly.',
    vi:
      'Điều khoản Sử dụng và Chính sách Bảo mật cho từng nền tảng mạng xã hội tích hợp với Social Panel. Các trang này được công khai — không cần đăng nhập — để reviewer của nền tảng và người dùng có thể đọc trực tiếp.',
  },
  perPlatformTitle: {
    en: 'Per-platform legal documents',
    vi: 'Văn bản pháp lý theo từng nền tảng',
  },
  perPlatformDescription: {
    en:
      'Each integration has its own Terms and Privacy Policy that reflects the exact OAuth scopes, data types collected, and how that data is used.',
    vi:
      'Mỗi tích hợp có Điều khoản và Chính sách Bảo mật riêng, phản ánh chính xác OAuth scopes, loại dữ liệu thu thập và mục đích sử dụng.',
  },
  viewTerms: { en: 'Terms of Service', vi: 'Điều khoản Sử dụng' },
  viewPrivacy: { en: 'Privacy Policy', vi: 'Chính sách Bảo mật' },
  effectiveDateLabel: { en: 'Effective date', vi: 'Ngày hiệu lực' },
  lastUpdatedLabel: { en: 'Last updated', vi: 'Cập nhật lần cuối' },
  applicableTo: { en: 'Applicable to', vi: 'Áp dụng cho' },
  tableOfContents: { en: 'On this page', vi: 'Mục lục trang' },
  contactUs: { en: 'Contact', vi: 'Liên hệ' },
  contactPrompt: {
    en: 'Have a question about this policy?',
    vi: 'Câu hỏi liên quan tới chính sách này?',
  },
  emailUs: { en: 'Email us at', vi: 'Gửi email tới' },
  copyright: {
    en: 'All rights reserved.',
    vi: 'Bảo lưu mọi quyền.',
  },
  switchToEN: { en: 'EN', vi: 'EN' },
  switchToVI: { en: 'VI', vi: 'VI' },

  // Footer
  footerAbout: {
    en:
      'Social Panel is a unified dashboard to compose, schedule and publish content across multiple social platforms.',
    vi:
      'Social Panel là bảng điều khiển hợp nhất để soạn, lên lịch và xuất bản nội dung trên nhiều nền tảng mạng xã hội.',
  },
  footerLegal: { en: 'Legal', vi: 'Pháp lý' },
  footerNavLegalIndex: { en: 'Legal Center', vi: 'Trung tâm Pháp lý' },
  footerNavAllTerms: { en: 'All Terms', vi: 'Tất cả Điều khoản' },
  footerNavAllPrivacy: { en: 'All Privacy Policies', vi: 'Tất cả Chính sách Bảo mật' },
  footerPlatforms: { en: 'Integrations', vi: 'Tích hợp' },

  // Terms common
  termsDocTitle: {
    en: 'Terms of Service',
    vi: 'Điều khoản Sử dụng',
  },
  termsIntroBeforePlatform: {
    en: 'These Terms of Service govern your use of the',
    vi: 'Điều khoản Sử dụng này điều chỉnh việc sử dụng tích hợp',
  },
  termsIntroAfterPlatform: {
    en:
      'integration provided by Social Panel. By connecting your account, you agree to these Terms and to the platform-specific policies listed below.',
    vi:
      'do Social Panel cung cấp. Bằng việc kết nối tài khoản, bạn đồng ý với các Điều khoản này và các chính sách riêng của nền tảng được liệt kê bên dưới.',
  },

  // Terms sections
  s_acceptance: { en: '1. Acceptance of Terms', vi: '1. Chấp thuận Điều khoản' },
  s_acceptance_body: {
    en:
      'By creating an account, connecting a social platform, or otherwise using Social Panel, you confirm that you are at least 18 years old (or the age of majority in your jurisdiction) and that you have read, understood, and agree to be bound by these Terms. If you do not agree, do not use the service.',
    vi:
      'Bằng việc tạo tài khoản, kết nối nền tảng mạng xã hội, hoặc sử dụng Social Panel, bạn xác nhận đã đủ 18 tuổi (hoặc tuổi thành niên theo luật pháp địa phương), đã đọc, hiểu và đồng ý chịu sự ràng buộc của Điều khoản này. Nếu không đồng ý, vui lòng không sử dụng dịch vụ.',
  },

  s_service: { en: '2. Description of the Service', vi: '2. Mô tả Dịch vụ' },
  s_service_body_intro: {
    en:
      'Social Panel provides authenticated users with tools to compose, schedule, and publish content on third-party social platforms via their official APIs. For this particular integration, we use the following OAuth scopes and access the following data:',
    vi:
      'Social Panel cung cấp cho người dùng đã xác thực các công cụ để soạn, lên lịch và xuất bản nội dung trên các nền tảng mạng xã hội bên thứ ba thông qua API chính thức. Đối với tích hợp này, chúng tôi sử dụng các OAuth scopes và truy cập các dữ liệu sau:',
  },
  s_service_scopes_label: { en: 'OAuth scopes requested', vi: 'OAuth scopes yêu cầu' },
  s_service_data_label: { en: 'Data accessed', vi: 'Dữ liệu được truy cập' },
  s_service_purpose_label: { en: 'Purpose of access', vi: 'Mục đích truy cập' },

  s_account: { en: '3. Account and Authentication', vi: '3. Tài khoản và Xác thực' },
  s_account_body: {
    en:
      'You authenticate with the platform via the platform\'s official OAuth flow. We never store your platform password; we store an OAuth access token (and refresh token where applicable) that allows us to call the API on your behalf within the scopes you granted. You may revoke our access at any time directly in your platform settings; doing so will immediately disable the integration on our side.',
    vi:
      'Bạn xác thực với nền tảng thông qua luồng OAuth chính thức của nền tảng đó. Chúng tôi không lưu trữ mật khẩu nền tảng; chúng tôi chỉ lưu OAuth access token (và refresh token nếu có) để gọi API thay mặt bạn trong phạm vi scopes bạn đã cấp. Bạn có thể thu hồi quyền truy cập của chúng tôi bất cứ lúc nào trong phần cài đặt của nền tảng; khi đó tích hợp ở phía chúng tôi sẽ ngừng hoạt động ngay lập tức.',
  },

  s_userResp: { en: '4. Your Responsibilities', vi: '4. Trách nhiệm của Người dùng' },
  s_userResp_body: {
    en:
      'You are solely responsible for the content you publish through Social Panel. You agree not to use the service to publish content that is illegal, infringing, defamatory, harassing, sexually explicit involving minors, spam, malware, or that otherwise violates the destination platform\'s Community Guidelines, Acceptable Use Policy, or Developer Terms. Violations may result in immediate suspension of your account and revocation of platform tokens.',
    vi:
      'Bạn hoàn toàn chịu trách nhiệm về nội dung bạn xuất bản qua Social Panel. Bạn cam kết không sử dụng dịch vụ để đăng nội dung bất hợp pháp, vi phạm bản quyền, phỉ báng, quấy rối, nội dung khiêu dâm liên quan đến trẻ vị thành niên, spam, malware, hoặc vi phạm Community Guidelines, Acceptable Use Policy, hay Developer Terms của nền tảng đích. Vi phạm có thể dẫn đến đình chỉ tài khoản tức thì và thu hồi token nền tảng.',
  },

  s_platformPolicy: {
    en: '5. Compliance with Platform Policies',
    vi: '5. Tuân thủ Chính sách Nền tảng',
  },
  s_platformPolicy_body: {
    en:
      'Your use of this integration is also subject to the policies of the upstream platform. By connecting, you confirm you have reviewed and agree to abide by:',
    vi:
      'Việc sử dụng tích hợp này cũng tuân thủ theo các chính sách của nền tảng gốc. Bằng việc kết nối, bạn xác nhận đã xem và đồng ý tuân thủ:',
  },

  s_dataRights: { en: '6. Data and Your Rights', vi: '6. Dữ liệu và Quyền của Bạn' },
  s_dataRights_body: {
    en:
      'How we collect, store, and process your data is described in our Privacy Policy for this integration. You may request export or deletion of your data at any time by emailing the contact address listed below; we will respond within 30 days.',
    vi:
      'Cách chúng tôi thu thập, lưu trữ và xử lý dữ liệu của bạn được mô tả trong Chính sách Bảo mật cho tích hợp này. Bạn có thể yêu cầu xuất hoặc xóa dữ liệu bất cứ lúc nào bằng cách email đến địa chỉ liên hệ dưới đây; chúng tôi sẽ phản hồi trong 30 ngày.',
  },

  s_termination: { en: '7. Suspension and Termination', vi: '7. Tạm dừng và Chấm dứt' },
  s_termination_body: {
    en:
      'We may suspend or terminate your access to the service, or to a specific platform integration, immediately and without prior notice if we reasonably believe you have violated these Terms, abused the API, or put us at legal or technical risk. You may stop using the service at any time by disconnecting integrations and deleting your account from the dashboard settings.',
    vi:
      'Chúng tôi có thể tạm dừng hoặc chấm dứt quyền truy cập của bạn vào dịch vụ, hoặc một tích hợp cụ thể, ngay lập tức và không cần thông báo trước nếu chúng tôi tin rằng bạn đã vi phạm Điều khoản này, lạm dụng API, hoặc đặt chúng tôi vào rủi ro pháp lý hay kỹ thuật. Bạn có thể ngừng sử dụng dịch vụ bất cứ lúc nào bằng cách ngắt kết nối tích hợp và xóa tài khoản trong phần cài đặt dashboard.',
  },

  s_disclaimer: { en: '8. Disclaimer and Limitation of Liability', vi: '8. Tuyên bố Miễn trừ và Giới hạn Trách nhiệm' },
  s_disclaimer_body: {
    en:
      'The service is provided "as is" and "as available" without warranty of any kind. Social Panel is an independent third-party tool and is not affiliated with, endorsed by, or sponsored by the platforms it integrates with. To the maximum extent permitted by law, we are not liable for any indirect, incidental, consequential, or punitive damages arising from your use of, or inability to use, the service — including damages resulting from platform API changes, downtime, or content removed by the upstream platform.',
    vi:
      'Dịch vụ được cung cấp "nguyên trạng" và "theo khả năng sẵn có" không kèm bất kỳ bảo đảm nào. Social Panel là công cụ độc lập của bên thứ ba và không liên kết, không được chứng thực, không được tài trợ bởi các nền tảng mà nó tích hợp. Trong phạm vi tối đa pháp luật cho phép, chúng tôi không chịu trách nhiệm cho bất kỳ thiệt hại gián tiếp, ngẫu nhiên, hệ quả hoặc trừng phạt nào phát sinh từ việc bạn sử dụng hoặc không thể sử dụng dịch vụ — bao gồm thiệt hại do thay đổi API nền tảng, downtime, hoặc nội dung bị nền tảng gỡ bỏ.',
  },

  s_changes: { en: '9. Changes to These Terms', vi: '9. Thay đổi Điều khoản' },
  s_changes_body: {
    en:
      'We may update these Terms from time to time. Material changes will be announced on this page with a new "Effective date" at the top. Continued use of the service after such changes constitutes acceptance.',
    vi:
      'Chúng tôi có thể cập nhật Điều khoản này theo thời gian. Các thay đổi quan trọng sẽ được công bố trên trang này kèm "Ngày hiệu lực" mới ở đầu trang. Việc tiếp tục sử dụng dịch vụ sau khi có thay đổi đồng nghĩa với việc bạn chấp thuận.',
  },

  s_contact: { en: '10. Contact', vi: '10. Liên hệ' },
  s_contact_body: {
    en: 'For questions about these Terms, please contact us at',
    vi: 'Đối với câu hỏi về Điều khoản này, vui lòng liên hệ',
  },

  // Privacy Policy
  privacyDocTitle: {
    en: 'Privacy Policy',
    vi: 'Chính sách Bảo mật',
  },
  privacyIntroBeforePlatform: {
    en: 'This Privacy Policy explains how Social Panel collects, uses, stores, and shares data when you connect your',
    vi: 'Chính sách Bảo mật này giải thích cách Social Panel thu thập, sử dụng, lưu trữ và chia sẻ dữ liệu khi bạn kết nối tài khoản',
  },
  privacyIntroAfterPlatform: {
    en: 'account to our service.',
    vi: 'với dịch vụ của chúng tôi.',
  },

  p_collected: { en: '1. Information We Collect', vi: '1. Thông tin Chúng tôi Thu thập' },
  p_collected_intro: {
    en: 'When you connect this integration, we collect the data listed below — and only this data — strictly to provide the features of Social Panel:',
    vi: 'Khi bạn kết nối tích hợp này, chúng tôi chỉ thu thập các dữ liệu được liệt kê dưới đây — và chỉ dữ liệu này — phục vụ cung cấp các tính năng của Social Panel:',
  },

  p_use: { en: '2. How We Use Your Information', vi: '2. Cách Chúng tôi Sử dụng Thông tin' },
  p_use_body: {
    en:
      'We use the collected data exclusively for the purpose described above for this integration. We do not sell your personal data. We do not use your platform data to train AI models. We do not use it for advertising. Tokens are used solely to call the platform\'s API on your behalf within the scopes you granted.',
    vi:
      'Chúng tôi chỉ sử dụng dữ liệu thu thập cho mục đích đã nêu ở trên đối với tích hợp này. Chúng tôi không bán dữ liệu cá nhân của bạn. Chúng tôi không sử dụng dữ liệu nền tảng để huấn luyện mô hình AI. Chúng tôi không sử dụng cho mục đích quảng cáo. Token chỉ được sử dụng để gọi API của nền tảng thay mặt bạn trong phạm vi scopes bạn đã cấp.',
  },

  p_share: { en: '3. Sharing and Disclosure', vi: '3. Chia sẻ và Tiết lộ' },
  p_share_body: {
    en:
      'We do not share your data with third parties except: (a) the upstream platform itself when calling its API on your behalf, (b) infrastructure subprocessors (hosting, database, error monitoring) bound by contractual confidentiality, and (c) when required by law, court order, or to protect the rights, property or safety of Social Panel, our users or others.',
    vi:
      'Chúng tôi không chia sẻ dữ liệu của bạn với bên thứ ba, ngoại trừ: (a) chính nền tảng gốc khi gọi API của nó thay mặt bạn, (b) các nhà cung cấp hạ tầng (hosting, database, error monitoring) bị ràng buộc bởi nghĩa vụ bảo mật theo hợp đồng, và (c) khi pháp luật yêu cầu, theo lệnh tòa án, hoặc để bảo vệ quyền, tài sản và an toàn của Social Panel, người dùng hoặc bên khác.',
  },

  p_store: { en: '4. Data Storage and Security', vi: '4. Lưu trữ và Bảo mật Dữ liệu' },
  p_store_body: {
    en:
      'Data is stored on managed cloud infrastructure with encryption in transit (TLS 1.2+) and at rest. OAuth tokens are stored encrypted in our database and are accessible only to the application processes that need them to call the platform API. Access to the production database is restricted to authorized engineers and audited.',
    vi:
      'Dữ liệu được lưu trên hạ tầng cloud được quản lý với mã hóa khi truyền (TLS 1.2+) và khi lưu trữ. OAuth token được lưu mã hóa trong database và chỉ truy cập được bởi các process cần để gọi API nền tảng. Quyền truy cập database production chỉ giới hạn cho các kỹ sư được ủy quyền và có audit.',
  },

  p_retain: { en: '5. Data Retention', vi: '5. Lưu giữ Dữ liệu' },
  p_retain_body: {
    en:
      'We retain your data for as long as the integration is connected. When you disconnect the integration, revoke our access from the platform, or delete your Social Panel account, we delete or anonymize the associated tokens and stored platform data within 30 days, except where retention is required by law (e.g. audit, tax, or legal hold).',
    vi:
      'Chúng tôi lưu giữ dữ liệu của bạn trong suốt thời gian tích hợp còn kết nối. Khi bạn ngắt tích hợp, thu hồi quyền truy cập từ nền tảng, hoặc xóa tài khoản Social Panel, chúng tôi sẽ xóa hoặc ẩn danh các token và dữ liệu nền tảng liên quan trong vòng 30 ngày, trừ trường hợp phải lưu giữ theo luật (ví dụ: audit, thuế, legal hold).',
  },

  p_rights: { en: '6. Your Rights', vi: '6. Quyền của Bạn' },
  p_rights_body: {
    en:
      'You may at any time: (a) view what platform integrations are connected and what data we hold via your dashboard, (b) request a data export, (c) request deletion of your data, (d) revoke our access directly in the platform\'s authorization settings. Where applicable laws grant additional rights (GDPR access/erasure/portability/objection, CCPA right to know/delete), we will honor them.',
    vi:
      'Bạn có quyền bất cứ lúc nào: (a) xem các tích hợp nền tảng đang kết nối và dữ liệu chúng tôi nắm giữ thông qua dashboard, (b) yêu cầu xuất dữ liệu, (c) yêu cầu xóa dữ liệu, (d) thu hồi quyền truy cập của chúng tôi trực tiếp trong cài đặt ủy quyền của nền tảng. Khi luật áp dụng cấp quyền bổ sung (GDPR access/erasure/portability/objection, CCPA right to know/delete), chúng tôi sẽ thực hiện.',
  },

  p_children: { en: '7. Children\'s Privacy', vi: '7. Quyền Riêng tư của Trẻ em' },
  p_children_body: {
    en:
      'Social Panel is not directed to children under 18. We do not knowingly collect personal data from children under 18. If you believe a child has provided personal data, please contact us and we will delete it.',
    vi:
      'Social Panel không hướng đến trẻ em dưới 18 tuổi. Chúng tôi không cố ý thu thập dữ liệu cá nhân của trẻ em dưới 18. Nếu bạn cho rằng có trẻ em đã cung cấp dữ liệu cá nhân, vui lòng liên hệ và chúng tôi sẽ xóa.',
  },

  p_international: { en: '8. International Transfers', vi: '8. Chuyển Dữ liệu Quốc tế' },
  p_international_body: {
    en:
      'Our infrastructure may be located in data centers outside your country of residence. By using the service, you acknowledge that your data may be transferred to and processed in those jurisdictions, subject to appropriate safeguards.',
    vi:
      'Hạ tầng của chúng tôi có thể đặt tại các data center ngoài quốc gia cư trú của bạn. Bằng việc sử dụng dịch vụ, bạn xác nhận rằng dữ liệu của bạn có thể được chuyển và xử lý tại các khu vực pháp lý đó, với các biện pháp bảo vệ phù hợp.',
  },

  p_changes: { en: '9. Changes to This Policy', vi: '9. Thay đổi Chính sách này' },
  p_changes_body: {
    en:
      'We may update this Privacy Policy from time to time. Material changes will be reflected by an updated "Effective date" at the top of this page. We encourage you to review this page periodically.',
    vi:
      'Chúng tôi có thể cập nhật Chính sách Bảo mật theo thời gian. Các thay đổi quan trọng sẽ được phản ánh qua "Ngày hiệu lực" mới ở đầu trang. Chúng tôi khuyến khích bạn xem lại trang này định kỳ.',
  },

  p_contact: { en: '10. Contact Us', vi: '10. Liên hệ' },
  p_contact_body: {
    en: 'For questions about this Privacy Policy or to exercise any of your rights, contact us at',
    vi: 'Đối với câu hỏi về Chính sách Bảo mật này hoặc để thực hiện quyền của bạn, vui lòng liên hệ',
  },

  // Misc
  notFoundTitle: { en: 'Platform not found', vi: 'Không tìm thấy nền tảng' },
  notFoundBody: {
    en: 'The platform you are looking for does not exist. Return to the Legal Center to see all available integrations.',
    vi: 'Nền tảng bạn tìm kiếm không tồn tại. Quay về Trung tâm Pháp lý để xem các tích hợp khả dụng.',
  },
};
